import React, { Fragment, useState, useEffect } from 'react';
import man from '../../assets/images/dashboard/profile.jpg'
import { LogIn, User, MessageSquare, Maximize, MessageCircle } from 'react-feather';
import { useNavigate } from 'react-router-dom'
import { firebase_app } from '../../data/config'
import { useAuth0 } from '@auth0/auth0-react'
import { classes } from '../../data/layouts';
import ChatWidget from './ChatWidget';
import authAxios from "../../services/Token"; // Asegúrate de importar authAxios

const Rightbar = () => {
  const history = useNavigate();
  const [profile, setProfile] = useState('');
  const [name, setName] = useState('')
  const [moonlight, setMoonlight] = useState(false)
  const [chatOpen, setChatOpen] = useState(false)
  const [Administrador, setAdministrador] = useState('');
  const [unreadMessages, setUnreadMessages] = useState(0); // Estado para mensajes no leídos

  // Función segura para obtener datos de localStorage
  const getLocalStorageItem = (key, defaultValue = '') => {
    try {
      const item = localStorage.getItem(key);
      return item !== null ? item : defaultValue;
    } catch {
      return defaultValue;
    }
  };

  const { logout } = useAuth0();
  
  // Obtener datos de autenticación de forma segura
  const authenticated = (() => {
    try {
      return JSON.parse(localStorage.getItem("authenticated")) || false;
    } catch {
      return false;
    }
  })();
  
  const auth0_profile = (() => {
    try {
      return JSON.parse(localStorage.getItem("auth0_profile")) || {};
    } catch {
      return {};
    }
  })();

  // Función para cargar mensajes no leídos
  const loadUnreadMessages = async () => {
    try {
      const response = await authAxios.get('/chat/unread');
      if (response.data?.success) {
        setUnreadMessages(response.data.data.total);
      }
    } catch (error) {
      console.error('Error loading unread messages:', error);
    }
  };

  // Cargar datos iniciales
  useEffect(() => {
    setProfile(getLocalStorageItem('profileURL') || man);
    setName(getLocalStorageItem('Name'));
    setAdministrador(getLocalStorageItem('admin'));
    
    if (getLocalStorageItem("layout_version") === "dark-only") {
      setMoonlight(true);
      document.body.classList.add("dark-only");
    }

    // Cargar mensajes no leídos iniciales
    loadUnreadMessages();

    // Configurar polling para actualizar mensajes no leídos cada 5 segundos
    const interval = setInterval(() => {
      loadUnreadMessages();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Efecto para recargar mensajes cuando se abre/cierra el chat
  useEffect(() => {
    if (!chatOpen) {
      // Cuando se cierra el chat, recargar mensajes no leídos
      loadUnreadMessages();
    }
  }, [chatOpen]);

  const Logout_From_Firebase = () => {
    try {
      localStorage.removeItem('profileURL');
      localStorage.removeItem('token');
      localStorage.setItem("rol", "null");
      firebase_app.auth().signOut();
      history(`${process.env.PUBLIC_URL}/login`);
    } catch (error) {
      console.error('Error en logout:', error);
    }
  };

  const Logout_From_Auth0 = () => {
    try {
      localStorage.removeItem("auth0_profile");
      localStorage.setItem("authenticated", "false");
      localStorage.setItem("rol", "null");
      history(`${process.env.PUBLIC_URL}/login`);
      logout();
    } catch (error) {
      console.error('Error en logout:', error);
    }
  };

  const defaultLayoutObj = classes.find(item => Object.values(item).pop(1) === 'compact-wrapper');
  const layout = getLocalStorageItem('layout') || Object.keys(defaultLayoutObj || {}).pop() || 'compact-wrapper';

  const UserMenuRedirect = (redirect) => {
    history(redirect);
  };

  const goFull = () => {
    try {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    } catch (error) {
      console.error('Error en fullscreen:', error);
    }
  };

  const MoonlightToggle = (light) => {
    try {
      if (light) {
        setMoonlight(!light);
        document.body.classList.add("light");
        document.body.classList.remove("dark-only");
        localStorage.setItem('layout_version', 'light');
      } else {
        setMoonlight(!light);
        document.body.classList.remove("light");
        document.body.classList.add("dark-only");
        localStorage.setItem('layout_version', 'dark-only');
      }
    } catch (error) {
      console.error('Error en moonlight toggle:', error);
    }
  };

  // Manejador para abrir/cerrar chat
  const handleChatToggle = () => {
    setChatOpen(!chatOpen);
    if (!chatOpen) {
      // Cuando se abre el chat, resetear contador de no leídos
      setUnreadMessages(0);
    }
  };

  return (
    <Fragment>
      <div className="nav-right col-8 pull-right right-header p-0">
        <ul className="nav-menus">
          <li><span className="header-search"><b>--Intranet--</b></span></li>
      
          {/* Icono de Chat con notificación */}
          <li className="chat-icon-container">
            <div 
              onClick={handleChatToggle} 
              className="chat-icon-wrapper"
              style={{ 
                color: 'white', 
                position: 'relative', 
                cursor: 'pointer', 
                padding: '8px 12px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <MessageCircle size={20} color="white" />
              {unreadMessages > 0 && (
                <span className="chat-notification-badge">
                  {unreadMessages > 99 ? '99+' : unreadMessages}
                </span>
              )}
            </div>
            <ChatWidget 
              isOpen={chatOpen} 
              onClose={() => {
                setChatOpen(false);
                loadUnreadMessages(); // Recargar contador al cerrar
              }} 
            />
          </li>
          
          <li>
            <div className="mode" onClick={() => MoonlightToggle(moonlight)} >
              {moonlight ? <i className="fa fa-lightbulb-o"></i> : <i className="fa fa-moon-o"></i>}
            </div>
          </li>
        
          <li className="maximize">
            <button 
              className="text-dark" 
              style={{ color: 'white', background: 'none', border: 'none', cursor: 'pointer' }} 
              onClick={goFull}
            >
              <Maximize color="white" />
            </button>
          </li>
          
          <li className="profile-nav onhover-dropdown p-0">
            <div className="media profile-media">
              <img 
                className="b-r-10" 
                src={authenticated ? (auth0_profile?.picture || man) : profile} 
                alt="" 
                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
              />
              <div className="media-body">
                <span>{authenticated ? (auth0_profile?.name || '') : name}</span>
                <p className="mb-0 font-roboto" style={{ color: 'white' }}>
                  {Administrador} <i className="middle fa fa-angle-down"></i>
                </p>
              </div>
            </div>
            <ul className="profile-dropdown onhover-show-div">
              <li onClick={() => UserMenuRedirect(`${process.env.PUBLIC_URL}/pages/perfil/${layout}`)}>
                <User size={16} /><span>Mi cuenta</span>
              </li>
              <li onClick={authenticated ? Logout_From_Auth0 : Logout_From_Firebase}>
                <LogIn size={16} /><span>Salir</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </Fragment>
  );
};

export default Rightbar;